<template>
    <div class="pa-2">
        <div class="row">
            <div class="col-xs-3">
                <v-select :items="fsucursales" item-value="id" v-model="search" clearable label="Sucursal:" /> 
            </div>
            <div class="col-xs-3">
                <v-select :items="fpuntos" item-value="id" v-model="search" clearable label="Punto de venta:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festado_sistema" item-value="id" v-model="search" clearable label="Estado sistema:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="festados" item-value="id" v-model="search" clearable label="Estado:" /> 
            </div>
            <div class="col-xs-2">
                <v-select :items="fdocsector" item-value="id" v-model="search" clearable label="Doc sector:" /> 
            </div>
        </div> 

        <v-data-table
            :headers="headers"
            :items="desserts"
            :loading="loading" 
            :search="search"
            :custom-filter="custom_filter"
            dense
            xitems-per-page="150"
            xdisable-items-per-page
            xdisable-pagination 
            xhide-default-footer
        >

        <template v-slot:[`item.registradoSistema`]="{ item }">
            {{ item.registradoSistema?'SI':'NO' }}
        </template>

        </v-data-table>
    </div>
</template>

<script>
import { headers } from './utils.ts'
import xaxios from '@/xaxios';

export default {
    components:{ },
    data: () => ({ 
        headers,
        loading: false,
        desserts:[],
        search: '',
        fsucursales: [
            {id:'sucursal-0', text:'Sucursal 0'},
            {id:'sucursal-1', text:'Sucursal 1'},
        ],
        fpuntos: [
            {id:'punto-0', text:'Punto 0'},
            {id:'punto-1', text:'Punto 1'},
            {id:'punto-2', text:'Punto 2'},
            {id:'punto-3', text:'Punto 3'},
        ],
        festado_sistema: [
            {id:'estadosys-true', text:'Registrado'},
            {id:'estadosys-false', text:'No registrado'}, 
        ],
        festados: [
            {id:'estado-VALIDA', text:'VALIDA'}, 
        ],
        fdocsector: [
            {id:'docsector-1', text:'Sector 1'}, 
            {id:'docsector-3', text:'Sector 3'}, 
            {id:'docsector-11', text:'Sector 11'}, 
        ]
    }),
    methods:{ 
        async get_datos(endpoint,mes, anio,nit){
            this.desserts = [];
            this.loading = true;
            // window.console.log('----->>>>', nit);
            let url = process.env.VUE_APP_FACT_REST+`/facturacion/facturas/${endpoint}?mes=${mes}&anio=${anio}`;
            let config = {
                method: 'get',
                url: url,
                headers: { 'Content-Type': 'application/json',apikey: nit.apikey },
            };
            let res = await await xaxios.request(config).then(({data})=>data).catch(e=>e)

            if(res && res.data ){
                const sucursalesMap = new Map();
                const puntosMap = new Map();
                const estadosMap = new Map();
                const docSectorMap = new Map();

                for(let i=0;i<=res.data.length;i++){
                    let x = res.data[i];
                    if(!x) continue;
                    let o = {id:'sucursal-'+x.sucursalCuf,text:'Sucursal '+x.sucursalCuf};
                    sucursalesMap.set(o.id, o);
                    
                    let o2 = {id:'punto-'+x.puntoVentaCuf,text:'Punto '+x.puntoVentaCuf};
                    puntosMap.set(o2.id, o2);
                    
                    let o3 = {id:'estado-'+x.estado,text:''+x.estado};
                    estadosMap.set(o3.id, o3);
                    
                    let o4 = {id:'docsector-'+x.tipoDocumentoSectorCuf,text:''+x.tipoDocumentoSectorCuf};
                    docSectorMap.set(o4.id, o4);
                }

                this.fsucursales = Array.from(sucursalesMap.values());
                this.fpuntos = Array.from(puntosMap.values());
                this.festados = Array.from(estadosMap.values());
                this.fdocsector = Array.from(docSectorMap.values());
                
                this.desserts = res.data;
            }
            this.loading = false;
        },
        custom_filter(value,search,item){
            if(!search) return true;

            if((search+'').startsWith('sucursal-')){
                let id = (search+'').split('-')[1];
                if(item.sucursalCuf == id) return true;
                return false;
            }
            else if((search+'').startsWith('punto-')){
                let id = (search+'').split('-')[1];
                if(item.puntoVentaCuf == id) return true;
                return false;
            }
            else if((search+'').startsWith('estadosys-')){
                let id = (search+'').split('-')[1];
                // window.console.log('item.registradoSistema == id',item.registradoSistema+'',id);
                if(item.registradoSistema+'' == id) return true;
                return false;
            }
            else if((search+'').startsWith('estado-')){
                let id = (search+'').split('-')[1];
                if(item.estado == id) return true;
                return false;
            }
            else if((search+'').startsWith('docsector-')){
                let id = (search+'').split('-')[1];
                if(item.tipoDocumentoSectorCuf == id) return true;
                return false;
            }
            // window.console.log('--???',value,search,item);
            
        },
    },
    mounted(){ 
        // this.get_datos();
    }
}

</script>
